import { IDataTableHeader } from '@typings/components';

export const INTRANET_USERS_TABLE_HEADERS: IDataTableHeader[] = [
  { label: 'Name',   align: 'left',   width: '30%' },
  { label: 'Status', align: 'center', width: '30%' },
  { label: 'Email',  align: 'left',   width: '40%' },
];
